<template>
    <div :id="paymentMethodName">
        <empty-state
            v-if="paymentProcessing"
            class="overlay fullscreen"
            statusIcon="loading"
            :title="$t('bp.PaymentOptions.process.title')"
            :subtitle="$t('bp.PaymentOptions.process.subtitle')"
        ></empty-state>

        <div class="selectable-card collapsable-card"
             :class="{ 'active' : paymentMethodIsSelected(this.paymentMethodName) }">
            <div class="card-body">
                <div class="card-header"
                     @click="setPaymentMethod(paymentMethodName)"
                     v-scroll-to="{
                        el: '#'+paymentMethodName,
                        offset: -94,
                    }">
                    <p>
                        {{$t('bp.PaymentOptions.DropIn.title.p1')}}<span class="d-none d-sm-inline"> {{$t('bp.PaymentOptions.DropIn.title.p2')}}</span>
                    </p>
                    <ul class="payment-types">
<!--                        <li class="mb-0">-->
<!--                            <img src="https://res.cloudinary.com/wefix/image/upload/v1564673828/booking/paypal_card_icon.svg" alt="PayPal" class="card-icon" />-->
<!--                        </li>-->
                        <li class="mb-0">
                            <img src="https://res.cloudinary.com/wefix/image/upload/v1564673888/booking/visa_card_icon.svg" alt="Visa" class="card-icon" />
                        </li>
                        <li class="mb-0">
                            <img src="https://res.cloudinary.com/wefix/image/upload/v1564673915/booking/mastercard_card_icon.svg" alt="Mastercard" class="card-icon" />
                        </li>
<!--                        <li class="mb-0">-->
<!--                            <img src="https://res.cloudinary.com/wefix/image/upload/v1564673936/booking/amex_card_icon.svg" alt="American Express" class="card-icon" />-->
<!--                        </li>-->
                        <li class="mb-0">
                            <img srcset="https://res.cloudinary.com/wefix/image/upload/v1564673982/booking/discover_card_icon.png 1x, https://res.cloudinary.com/wefix/image/upload/v1564673982/booking/discover_card_icon_2x.png 2x"
                                 src="https://res.cloudinary.com/wefix/image/upload/v1564673982/booking/discover_card_icon.png"
                                 alt="Discover"
                                 class="card-icon" />
                        </li>
                    </ul>
                </div>
                <div class="collapse" :class="{ 'show': paymentMethodIsSelected(paymentMethodName) }">
                    <div class="collapse-body">
                        <div class="collapse-content">
                            <div id="dropin-container-3d-secure"></div>
                            <!-- Total Cost -->
                            <div class="col-12">
                                <table class="price-table grand-total">
                                    <tr class="total-cost">
                                        <td>{{$t('bp.total')}}</td>
                                        <td><span v-html="currencySymbol" v-if="countryCodeSetting !== 'DE'"></span>{{ cartTotal }} <span v-html="currencySymbol" v-if="countryCodeSetting === 'DE'"></span></td>
                                    </tr>
                                </table>
                            </div>
                            <button class="btn btn-block btn-lg btn-rounded continue-btn mb-3" :disabled="isLoading || !dropInInstance" @click="confirmBooking()">
                                <span v-if="isLoading"><i class="fa fa-spinner fa-pulse"></i></span>
                              <template v-if="carrier === 'ee'">{{$t('bp.PaymentOptions.DropIn.eePayButton')}}</template>
                              <template v-else>{{$t('bp.PaymentOptions.DropIn.PayButton')}}</template>
                            </button>
                            <div class="text-center" v-if="isBookingInStore">
                                <p class="mt-4 mb-2 text-sm">
                                    {{$t('bp.policy.p1')}} <router-link :to="{name: 'Terms'}" target="_blank">{{$t('bp.policy.p2')}}</router-link> {{$t('bp.policy.p3')}} <router-link :to="{name: 'Privacy'}" target="_blank">{{$t('bp.privacyPolicy')}}</router-link><template v-if="countryCodeSetting === 'DE'">{{$t('bp.policy.p4')}}</template>
                                </p>
                            </div>
                            <div class="text-center" v-if="carrier === 'ee'">
                                <p class="mt-4 mb-2 text-sm">
                                  {{$t('bp.PaymentOptions.DropIn.infoText')}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    const dropIn = require('braintree-web-drop-in');

    export default {
        name: "DropIn",

        props: [
            "isSelected"
        ],

        data() {
            return {
                dropInInstance: null,
                isLoading: false,
                paymentMethodName: "braintree",
                paymentProcessing: false,
            }
        },

        mounted() {
            this.isLoading = false;
            this.initDropIn();
        },

        computed: {
            ...mapGetters([
                "carrier",
                "carrierDetails",
                "booking",
                "braintreeToken",
                "cartTotal",
                "isBookingInStore",
                "paymentMethodIsSelected",
                "currencySymbol",
                "countryCodeSetting"
            ])
        },

        methods: {
            ...mapActions([
                "chargeBooking",
                "setPaymentMethod",
                "displayToast",
                "displayToastFromResponseObjectOfErrors",
                "retrieveBooking"
            ]),

            confirmBooking() {
                let self = this;

                if (this.isLoading) return;

                let threeDSecureData = {
                    amount: this.booking.cart.total_price,
                    email: this.booking.email,
                    billingAddress: {
                        givenName: this.booking.billing_first_name,
                        surname: this.booking.billing_last_name,
                        phoneNumber: this.booking.phone_number,
                        streetAddress: this.booking.billing_address.line_1,
                        extendedAddress: this.booking.billing_address.line_2,
                        city: this.booking.billing_address.town,
                        state: this.booking.billing_address.town,
                        postalCode: this.booking.billing_address.postcode,
                        countryCodeAlpha2: this.carrierDetails.countryCodeAlpha2
                    },
                    challengeRequested: true
                };

                this.isLoading = true;
                this.paymentProcessing = true;
                this.dropInInstance.requestPaymentMethod({threeDSecure: threeDSecureData}, function (err, payload) {
                    if (err) {
                        self.displayToast({text: this.$t('bp.Toast.paymentError'), type: "error"});
                        self.isLoading = false;
                        self.paymentProcessing = false;
                        return;
                    }

                    self.chargeBooking({
                        paidViaCredit: false,
                        paymentType: "braintree",
                        token: payload.nonce
                    }).then(() => {
                        self.isLoading = false;
                        self.paymentProcessing = false;

                        self.$router.push({name: 'bookingComplete'});
                    }).catch(errors => {
                        self.isLoading = false;
                        self.paymentProcessing = false;

                        if (errors.response.data.code === 'BK27') {
                            self.retrieveBooking().then(() => {
                                self.$router.push({name: 'checkout'});
                            });

                        } else if (errors.response.data.code === 'RBK15') {
                            self.$emit("iwOrderIsOow");

                        } else {
                            self.displayToastFromResponseObjectOfErrors(errors);
                            self.dropInInstance.clearSelectedPaymentMethod()
                        }
                    });
                });
            },

            initDropIn() {
                let self = this;

                const common = {
                    flow: 'checkout',
                    amount: this.cartTotal,
                    currency: this.carrierDetails.currency
                };

                dropIn.create({
                    authorization: this.braintreeToken,
                    selector: '#dropin-container-3d-secure',
                    locale: this.countryCodeSetting === "DE" ? "de_DE" : "en_GB",
                    threeDSecure: true,
                    card: {
                        overrides: {
                            fields: {
                                cvv: {
                                    maskInput: true
                                }
                            }
                        }
                    },
                    paypal: {
                        flow: common.flow,
                        amount: common.amount,
                        currency: common.currency
                    },
                    // paypalCredit: {
                    //     flow: common.flow,
                    //     amount: common.amount,
                    //     currency: common.currency
                    // },
                    // @see https://developers.braintreepayments.com/guides/apple-pay/configuration/javascript/v3
                    // applePay: {
                    //     displayName: 'My Store',
                    //     paymentRequest: {
                    //         total: {
                    //             label: 'My Store',
                    //             amount: common.amount
                    //         },
                    //         // We recommend collecting billing address information, at minimum
                    //         // billing postal code, and passing that billing postal code with all
                    //         // Apple Pay transactions as a best practice.
                    //         requiredBillingContactFields: ["postalAddress"]
                    //     }
                    // },
                    // @see https://developers.braintreepayments.com/guides/google-pay/configuration/javascript/v3
                    // googlePay: {
                    //     googlePayVersion: 2,
                    //     merchantId: 'merchant-id-from-google',
                    //     transactionInfo: {
                    //         totalPriceStatus: 'FINAL',
                    //         totalPrice: common.amount,
                    //         currencyCode: common.currency
                    //     },
                    //     allowedPaymentMethods: [{
                    //         type: 'CARD',
                    //         parameters: {
                    //             // We recommend collecting and passing billing address information with all Google Pay transactions as a best practice.
                    //             billingAddressRequired: true,
                    //             billingAddressParameters: {
                    //                 format: 'FULL'
                    //             }
                    //         }
                    //     }]
                    // }
                }, function (err, dropInInstance) {
                    if (err) {
                        // Handle any errors that might've occurred when creating Drop-in
                        return;
                    }

                    self.dropInInstance = dropInInstance;
                });
            }
        }
    }
</script>

<style>
    [data-braintree-id="choose-a-way-to-pay"],
    [data-braintree-id="choose-a-way-to-pay"] + .braintree-placeholder,
    [data-braintree-id="card-view-icons"] {
        display: none
    }

    [data-braintree-id="payment-options-container"] > div {
        background-color: #ffffff;
        border: 1px solid #dbdbdb;
        border-radius: 4px!important;
        margin-bottom: 10px;
        font-size: 0.938rem;
    }

    .braintree-upper-container:before {
        background: #fff;
    }

    [data-braintree-id="payment-options-container"] .braintree-option__label {
        font-size: 0.938rem;
        margin-left: 10px;
    }

    [data-braintree-id="payment-options-container"] .braintree-option__logo {
        order: 2;
    }
</style>